/* eslint-disable */

import { actionTypes } from "../pages/Companies/redux/actionTypes";

const upgradePlanReducer = (state = { isOpen: false, customerId: null, planData: null }, action) => {
  switch (action.type) {
    case actionTypes.OPEN_UPGRADE_FORM: {
      const { customerId, planData } = action.payload;
      return { 
        ...state, 
        isOpen: true,
        customerId,
        planData
      };
    }
    case actionTypes.CLOSE_UPGRADE_FORM:
      return { ...state, isOpen: false };
    default:
      return state;
  }
};
  
export default upgradePlanReducer;

export const openUpgradeForm = (customerId, planData) => ({
  type: actionTypes.OPEN_UPGRADE_FORM,
  payload: {
    customerId,
    planData
  }
});

export const closeUpgradeForm = () => ({
  type: actionTypes.CLOSE_UPGRADE_FORM
});
